import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function UsersList() {
  return <List />
}

export default hipladeTemplate(UsersList)
